export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '江门市黑八科技',

    /** 公司名称 */
    name: '江门市黑八科技有限公司',
    /** 公司微信 */
    wechat: 'q18138038373',
    /** 公司邮箱 */
    email: 'hei8@126.com',
    /** 公司手机 */
    phone: '18138038373',
    /** 公司电话 */
    tel: '0750-82661470',
    /** 公司地址 */
    address: '江门市新会区会城五谷里6号101自编18',
    /** 备案号 */
    keepOnRecordIcp: '粤ICP备2022077282号-1',

    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 121.526896,
        latitude: 31.24022,
        title: '小熊吉他',
        address: '江门市新会区会城五谷里6号101自编18'
    }
}


// WEBPACK FOOTER //
// ./src/config/index.js